import app from '../constants';

const GA_MEASUREMENT_ID = app.GA_MEASUREMENT_ID
    || (typeof process !== 'undefined' && process.env && process.env.REACT_APP_GA_MEASUREMENT_ID)
    || (typeof window !== 'undefined' && (window.REACT_APP_GA_MEASUREMENT_ID || window.GA_MEASUREMENT_ID))
    || '';

const getCookieValue = (name) => {
    if (typeof document === 'undefined') return '';
    const match = document.cookie.match(new RegExp(`(^|;\\s*)(${name})=([^;]*)`));
    return match ? decodeURIComponent(match[3]) : '';
};

export const getUserAnalyticsContext = () => ({
    user_name: getCookieValue('ThxUkApprover'),
    company_name: getCookieValue('ThxUkCompanyName'),
    account_code: getCookieValue('ThxUkAccountCode'),
    account_id: getCookieValue('ThxUkAccountId'),
    syrinx_user_id: getCookieValue('ThxUkSyrinxUserId'),
    wp_user_id: getCookieValue('ThxUkWpUser'),
    is_thx_user: getCookieValue('isTHXUser') === 'true',
});

export const initGA = () => {
    if (typeof window === 'undefined') return;

    if (GA_MEASUREMENT_ID && typeof document !== 'undefined' && !document.getElementById('google-analytics-gtag')) {
        const script = document.createElement('script');
        script.id = 'google-analytics-gtag';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        document.head.appendChild(script);
    }

    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
        window.gtag = (...args) => {
            window.dataLayer.push(args);
        };
    }

    const user = getUserAnalyticsContext();
    const userId = user.account_id ? `${user.account_id}_${user.syrinx_user_id || user.wp_user_id}` : (user.wp_user_id || undefined);

    window.gtag('js', new Date());

    if (GA_MEASUREMENT_ID) {
        window.gtag('config', GA_MEASUREMENT_ID, {
            user_id: userId,
            send_page_view: false,
        });
    }

    window.gtag('set', 'user_properties', {
        user_name: user.user_name,
        company_name: user.company_name,
        account_code: user.account_code,
        account_id: user.account_id,
        syrinx_user_id: user.syrinx_user_id,
        wp_user_id: user.wp_user_id,
        is_thx_user: user.is_thx_user ? 'yes' : 'no',
    });
};

export const trackEvent = (eventName, params = {}) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        const user = getUserAnalyticsContext();
        const payload = {
            ...user,
            ...params,
        };
        if (GA_MEASUREMENT_ID) {
            payload.send_to = GA_MEASUREMENT_ID;
        }
        window.gtag('event', eventName, payload);
    }
};

export const trackTabVisit = (tabName, path) => {
    trackEvent('account_tab_visit', {
        tab_name: tabName,
        page_path: path || (typeof window !== 'undefined' ? window.location.pathname : ''),
    });
};

export const trackOnHireReportDownload = (format = 'PDF') => {
    trackEvent('on_hire_report_download', {
        file_format: format,
        report_type: 'on_hire_report',
    });
};

export const trackHireRatesDownload = () => {
    trackEvent('hire_rates_download', {
        file_format: 'CSV',
        report_type: 'hire_rates_csv',
    });
};

export const trackLogin = () => {
    trackEvent('login', {
        method: 'wordpress_portal',
    });
};

export const trackLogout = () => {
    trackEvent('logout', {
        method: 'wordpress_portal',
    });
};
